export default __webpack_public_path__ + "static/media/landing-nimc.65b3eb45.png";